import { BrowserRouter, Route, Routes, Navigate } from 'react-router'
import { Layout } from './components/Layout'
import { routes } from './routes'
import Action from './views/Action'
import Help from './views/Help'
import LeftBank from './views/LeftBank'
import Rally from './views/Rally'
import Reel from './views/Reel'
import { oleshky2026 } from './data/rallies'
import Gallery from './components/Gallery/Gallery'
import { ralliesPhotos } from './assets/rallies'
import { Resources } from './components/Resources'

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* the Oleshky reel video to download; full screen, outside the site layout, not linked anywhere */}
        <Route path={routes.reel.path} element={<Reel />} />
        <Route path={routes.home.path} element={<Layout />}>
          <Route index element={<Navigate to={routes.oleshky.path} replace />} />
          <Route path={routes.oleshky.path} element={<Rally rally={oleshky2026} />} />
          <Route path={routes.leftBank.path} element={<LeftBank />} />
          <Route path={routes.action.path} element={<Action />} />
          <Route path='/home' element={<Navigate to={routes.action.path} replace />} />
          <Route path={routes.help.path} element={<Help />} />
          <Route
            path={routes.rallies.path}
            element={<Gallery id='gallery' images={ralliesPhotos} height='aspect-2/2' />}
          />
          <Route path={routes.resources.path} element={<Resources />} />
          <Route path='*' element={<Navigate to={routes.home.path} replace />} />
        </Route>
      </Routes>
    </BrowserRouter>
  )
}
